// Author thq
// Date 2021-07-04 23:20:31

class EmSppWarehousingSpw {
constructor({
        id = null,
        spwCode = '',
        spwStatus = '',
        spwIdAsu = '',
        spwTotalPrice = '',
        spwIdIct = '',
        spwNameUser = '',
        spwIdUser = '',
        spwDeliveryMan = '',
        spwDeliveryPhone = '',
        spwDeliveryDate = '',
        attachment = '',
        remark = '',
        attachmentList = ''}
= {}) {
    this.id = id;
    this.spwCode = spwCode;
    this.spwStatus = spwStatus;
    this.spwIdAsu = spwIdAsu;
    this.spwTotalPrice = spwTotalPrice;
    this.spwIdIct = spwIdIct;
    this.spwNameUser = spwNameUser;
    this.spwIdUser = spwIdUser;
    this.spwDeliveryMan = spwDeliveryMan;
    this.spwDeliveryPhone = spwDeliveryPhone;
    this.spwDeliveryDate = spwDeliveryDate;
    this.attachment = attachment;
    this.remark = remark;
    this.attachmentList = attachmentList;
}
}

function newEntity() {
return new EmSppWarehousingSpw();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'spwCode',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.spwCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spwStatus',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.spwStatus',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '0', text: '未入库' },
                            { value: '1', text: '已入库' }
            ]
        }
        },
        {
        key: 'spwNameAsu',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.spwNameAsu',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spwTotalPrice',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.spwTotalPrice',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spwNameIct',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.spwNameIct',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spwNameUser',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.spwNameUser',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spwDeliveryMan',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.spwDeliveryMan',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spwDeliveryPhone',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.spwDeliveryPhone',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spwDeliveryDate',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.spwDeliveryDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'attachmentList',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.attachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppWarehousingSpw.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    spwCodeFilter : "",
    spwStatusFilter : "",
    spwIdAsuFilter : "",
    spwNameUserFilter : "",
    spwIdUserFilter : "",
    spwDeliveryManFilter : "",
    spwDeliveryDateRteFilter : "",
    spwDeliveryDateLteFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'spwCodeFilter',
        label: 'label.em.spareparts.emSppWarehousingSpw.filter.spwCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spwStatusFilter',
        label: 'label.em.spareparts.emSppWarehousingSpw.filter.spwStatus',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '未入库' },
                { value: '1', text: '已入库' }
            ]
        }
        },
        {
        key: 'spwIdAsuFilter',
        label: 'label.em.spareparts.emSppWarehousingSpw.filter.spwIdAsu',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emArchSupplier'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'spwNameUserFilter',
        label: 'label.em.spareparts.emSppWarehousingSpw.filter.spwNameUser',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"spwIdUser":"id"}'
                }
        },
        {
        key: 'spwDeliveryManFilter',
        label: 'label.em.spareparts.emSppWarehousingSpw.filter.spwDeliveryMan',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spwDeliveryDateRteFilter',
        label: 'label.em.spareparts.emSppWarehousingSpw.filter.spwDeliveryDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'spwDeliveryDateLteFilter',
        label: 'label.em.spareparts.emSppWarehousingSpw.filter.spwDeliveryDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'spwIdAsu',
        label: 'label.em.spareparts.emSppWarehousingSpw.entity.spwIdAsu',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,required: true
            ,entity: 'emArchSupplier'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'spwNameUser',
        label: 'label.em.spareparts.emSppWarehousingSpw.entity.spwNameUser',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"spwIdUser":"id"}'
                }
        },
        {
        key: 'spwDeliveryMan',
        label: 'label.em.spareparts.emSppWarehousingSpw.entity.spwDeliveryMan',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'spwDeliveryPhone',
        label: 'label.em.spareparts.emSppWarehousingSpw.entity.spwDeliveryPhone',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spwDeliveryDate',
        label: 'label.em.spareparts.emSppWarehousingSpw.entity.spwDeliveryDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppWarehousingSpw.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'attachmentList',
        label: 'label.em.spareparts.emSppWarehousingSpw.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'attachment'
                }
        }
]

export {EmSppWarehousingSpw, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
